import { queryOptions, useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import productGroupQueryKeys from './productGroupQueryKeys'
import { getProductGroups } from '../service/productGroupService'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { Company } from '../../../types/company/Company'
import { ProductGroup } from '../../../types/product/product'

export const useProductGroups = <TData = ProductGroup[]>(
  companyId?: Company['id'],
  select?: (data: ProductGroup[]) => TData,
  enabled = true
) =>
  useQuery(
    queryOptions({
      queryKey: productGroupQueryKeys.list({ companyId }),
      queryFn: getProductGroups,
      enabled: !!companyId && enabled,
      gcTime: 15 * 60 * 1000,
      select: data => {
        const sorted = [...data].sort((a, b) => a.name.localeCompare(b.name))
        return select ? select(sorted) : (sorted as TData)
      }
    })
  )

export const useCtxProductGroups = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  return useProductGroups(companyId)
}
